export default __webpack_public_path__ + "static/media/btn_highcontrast_template.05ae4f34.svg";